export default "__VITE_ASSET__elAZW7E6__"